
export default {
  props: {
    colorOffers: Array
  },
  methods: {
    colorClick(item) {
      this.$router.push('/cars/' + this.$route.params.mark + '/' + this.$route.params.model + '/' + item.offer_external_id)
    },
    isActiveColor(external_id) {
      return external_id === Number(this.$route.params.car);
    }
  }
}
